import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WizardViewComponent } from './wizard-view.component';

@NgModule({
	imports: [CommonModule],
	declarations: [WizardViewComponent],
	exports: [WizardViewComponent]
})
export class WizardViewModule {

}

